import { render, staticRenderFns } from "./DetailParentStock.vue?vue&type=template&id=f567e92e&"
import script from "./DetailParentStock.vue?vue&type=script&lang=js&"
export * from "./DetailParentStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailParentStock.vue?vue&type=style&index=0&id=f567e92e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports